import { Clock3, Heart, MapPin } from 'lucide-react'

export default function ShopCard({ shop, selected, favorite, onSelect, onFavorite }) {
  return (
    <article
      className={`shop-card ${selected ? 'is-selected' : ''}`}
      onClick={() => onSelect(shop)}
      aria-current={selected ? 'true' : undefined}
    >
      <div className={`shop-card__number ${shop.cardImage ? 'has-image' : ''}`}>
        {shop.cardImage && (
          <img
            className="shop-card__image"
            src={shop.cardImage}
            alt=""
            aria-hidden="true"
            loading="lazy"
          />
        )}
        <span className="shop-card__verified" aria-hidden="true">VERIFIED</span>
        <span className="shop-card__index" aria-hidden="true">
          {String(shop.index + 1).padStart(2, '0')}
        </span>
        <button
          className={`favorite-button ${favorite ? 'is-favorite' : ''}`}
          type="button"
          onClick={(event) => {
            event.stopPropagation()
            onFavorite(shop.id)
          }}
          aria-label={favorite ? `${shop.name} 즐겨찾기 해제` : `${shop.name} 즐겨찾기`}
        >
          <Heart size={18} fill={favorite ? 'currentColor' : 'none'} />
        </button>
      </div>
      <div className="shop-card__body">
        <div className="shop-card__eyebrow">
          <span>{shop.category}</span>
          <span>{shop.region}</span>
        </div>
        <h2>{shop.name}</h2>
        <p>
          <MapPin size={14} />
          {shop.address}
        </p>
        <p>
          <Clock3 size={14} />
          {shop.hours}
        </p>
      </div>
    </article>
  )
}
